import TypesenseError from './TypesenseError'

export default class HTTPError extends TypesenseError {}
